export class ComponentEvent
{
	// static RELEASE = "component:release";
	public static DISABLE: string = "component:disable";
	public static ENABLE : string = "component:enable";
	public static LOADING: string = "component:loading";
}
